/** Project / label / filter palette from guides/Colors.md. Unknown names render as charcoal. */
export const PALETTE: readonly { name: string; hex: string; en: string; zh: string }[] = [
  { name: "berry_red", hex: "#B8255F", en: "Berry Red", zh: "浆果红" },
  { name: "red", hex: "#DC4C3E", en: "Red", zh: "红色" },
  { name: "orange", hex: "#C77100", en: "Orange", zh: "橙色" },
  { name: "yellow", hex: "#B29104", en: "Yellow", zh: "黄色" },
  { name: "olive_green", hex: "#949C31", en: "Olive Green", zh: "橄榄绿" },
  { name: "lime_green", hex: "#65A33A", en: "Lime Green", zh: "青柠绿" },
  { name: "green", hex: "#369307", en: "Green", zh: "绿色" },
  { name: "mint_green", hex: "#42A393", en: "Mint Green", zh: "薄荷绿" },
  { name: "teal", hex: "#148FAD", en: "Teal", zh: "青色" },
  { name: "sky_blue", hex: "#319DC0", en: "Sky Blue", zh: "天蓝" },
  { name: "light_blue", hex: "#6988A4", en: "Light Blue", zh: "浅蓝" },
  { name: "blue", hex: "#4180FF", en: "Blue", zh: "蓝色" },
  { name: "grape", hex: "#692EC2", en: "Grape", zh: "葡萄紫" },
  { name: "violet", hex: "#CA3FEE", en: "Violet", zh: "紫罗兰" },
  { name: "lavender", hex: "#A4698C", en: "Lavender", zh: "薰衣草" },
  { name: "magenta", hex: "#E05095", en: "Magenta", zh: "洋红" },
  { name: "salmon", hex: "#C9766F", en: "Salmon", zh: "鲑鱼粉" },
  { name: "charcoal", hex: "#808080", en: "Charcoal", zh: "炭灰" },
  { name: "grey", hex: "#999999", en: "Grey", zh: "灰色" },
  { name: "taupe", hex: "#8F7A69", en: "Taupe", zh: "灰褐" },
];

const BY_NAME = new Map(PALETTE.map((c) => [c.name, c.hex]));

export const colorHex = (name: string | null | undefined): string => BY_NAME.get(name ?? "") ?? "#808080";

/** Client priority (P1 = API 4) colors. */
export const PRIORITY_COLORS: Record<number, string> = { 4: "#D1453B", 3: "#EB8909", 2: "#246FE0", 1: "#808080" };

/** API priority (4 = p1) → client label number (1). */
export const clientPriority = (api: number) => 5 - api;

const AVATAR_COLORS = ["#E05095", "#4180FF", "#369307", "#C77100", "#692EC2", "#148FAD", "#B8255F", "#8F7A69"];
export function avatarColor(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length] ?? "#808080";
}
